module.exports = __webpack_public_path__ + "static/media/addpoint-demo.90d3605f.mp4";